// this func is temporary, will remove after new API response is available
export const parseNewObjectId = (res: string): string => {
  // AcknowledgedUpdateResult{matchedCount=0, modifiedCount=0, upsertedId=BsonObjectId{value=65a018333b24ec7a0e23c608}}
  const parsed = JSON.parse(res)

  return parsed._id.$oid
}
